const Data = {
    userType: "Owner",
    projectName: "chatscrumb",
    fullname: "Olusola Akinbode"
}

export default Data